import { Box, LinearProgress, makeStyles, Typography } from "@material-ui/core";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ImageType, SvgImage } from "../../../images/svg";
import { fromSecondsToHHMMSS } from "../../../utils/utils";

const useStyles = makeStyles((theme) => ({
  title: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "19px",
    fontWeight: 500,
    color: "#114668",
    alignSelf: "flex-start",
  },
  LinearProgress: {
    height: "5px",
    width: "100%",
    alignSelf: "start",
  },
  box: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    backgroundColor: "#fff",
    padding: "0px 24px 0px 24px",
    marginBottom: "24px",
  },
  horizontalBox: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  stopButton: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  buttonText: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "18px",
    fontWeight: 700,
    color: "#114668",
    marginLeft: "8px",
  },
  break: {
    width: "100%",
    height: "1px",
    marginBottom: "18px",
    marginTop: "18px",
    backgroundColor: "#bcbcbc",
  },
}));

const EventItem = ({ event, eklok, onStopOnItemClick }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const initialProgress = (100 / event.ACTION_DURATION) * event.STARTED_FROM;

  const [progress, setProgress] = React.useState(initialProgress);
  const [actualSecond, setActualSecond] = React.useState(event.STARTED_FROM);

  const commandsTypeText = {
    ACTIONS: t("mobile_frame.home.routines"),
    MUSICS: t("mobile_frame.home.musics"),
    MELODIES: t("mobile_frame.home.melodies"),
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 100;
        }
        const diff = 100 / event.ACTION_DURATION;
        return Math.min(oldProgress + diff, 100);
      });
      setActualSecond((actualSecond) => actualSecond + 1);
    }, 1000);

    return () => {
      clearInterval(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className={classes.box}>
      <Box className={classes.horizontalBox}>
        <Typography className={classes.title}>{event.ACTION_NAME}</Typography>
        <Typography className={classes.title}>
          {commandsTypeText[event.ACTION_TYPE]}
        </Typography>
      </Box>
      <LinearProgress
        className={classes.LinearProgress}
        variant="determinate"
        value={progress}
      />
      {progress === 100 ? (
        <Box className={classes.horizontalBox}>
          <Typography className={classes.title}>
            {t("mobile_frame.home.finished")}
          </Typography>
        </Box>
      ) : (
        <Box className={classes.horizontalBox}>
          <Typography className={classes.title}>
            {fromSecondsToHHMMSS(actualSecond)}
          </Typography>
          <Typography className={classes.title}>
            {fromSecondsToHHMMSS(event.ACTION_DURATION - actualSecond)}
          </Typography>
        </Box>
      )}
      {progress < 100 && (
        <Box
          className={classes.stopButton}
          onClick={() => {
            onStopOnItemClick(event);
          }}
        >
          <SvgImage type={ImageType.StopMini} />
          <Typography className={classes.buttonText}>{"STOP"}</Typography>
        </Box>
      )}
      <Box className={classes.break} />
    </Box>
  );
};

export default EventItem;
